import React, { useState, useEffect } from 'react';
import {
  Col,
  Row,
  Button,
  FormGroup,
  Label,
  Alert
} from 'reactstrap'
import {
  AvForm,
  AvGroup,
  AvInput
} from 'availity-reactstrap-validation'
import { useLocation } from "react-router-dom"
import { connect } from 'react-redux'
import Cookies from 'js-cookie'
import Slider from "react-slick"
import _ from 'lodash'

import TemplateContainerMain from 'Template/main'
import LoadingOverlay from 'components/Indicator/LoadingOverlay'
import { CaptchaContextProvider, useCaptchaContext } from 'components/ContextWrapper/captcha'
import Captcha from "components/Captcha"
import bg1 from 'assets/TemplateImages/media/start_ziel_03_.jpg'
import TennisBg from 'assets/images/tennis.jpg'
import { login, unlockAccount } from 'actions/login'
import { getToken } from 'utils/findCookieToken'
import { ApplyBranding } from 'utils/apply-color'
import { getPlatformConfig } from 'actions/platformConfig'
import { clearProfile } from 'actions/profile'
import { clearSelectedRole } from 'actions/role'
import { setSelectCenter } from 'actions/selectCenter'

const SliderSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  arrows: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  fade: true,
  initialSlide: 0,
  autoplay: true,
  adaptiveHeight: true
}

const SliderImageItemStyle = { 
  opacity: "0.4", 
  height: "100vh", 
  minHeight: "100vh",
  width: "100%",
  objectFit: "cover",
  objectPosition: "center" 
}

const Login = props => {
  const location = useLocation()
  const { buttonDisabled, setButtonDisabled } = useCaptchaContext()
  const [ state, setState ] = useState({
    email: '',
    password: '',
    accountLockIntervalId: 0
  })

  useEffect(() => {
    props.clearProfile()
    props.clearSelectedRole()
    props.setSelectCenter( {} )
    if( Cookies.get( 'SHOW_OUTDATED_TOKEN' ) && Cookies.get( 'SHOW_OUTDATED_TOKEN' ) === 'true' ) {
      Cookies.set( 'SHOW_OUTDATED_TOKEN', 'false' )
    }
    props.getPlatformConfig()

    const params = new URLSearchParams( location.search )
    const token = params.get( 'token' )
    token && props.unlockAccount( token )
  }, [])

  useEffect(() => {
    if( props.ajaxReducer.ajaxCallProgress === 0 ) {
      if( getToken( 'ACISO_SESSION_TOKEN' ).length > 2 ) {
        let params = new URLSearchParams( window.location.hash.substring( 2 ) )
        props.history.push( 
          params.get( 'prev' ) 
            ? params.get( 'prev' ).substring( 1 )
            : '/dashboard/main' 
        )
      }
    }
  }, [props.ajaxReducer.ajaxCallProgress])

  const handleKeyPress = ( event ) => {
    if( !buttonDisabled && event.key === 'Enter' ){
      props.login({ 
        email: state.email, 
        password: state.password, 
        accountLockIntervalId: state.accountLockIntervalId, 
        onChangeAccountLockIntervalId: intervalId => setState({ ...state, accountLockIntervalId: intervalId }) 
      })
    }
  }

  const handleRedirectLink = ( contentType ) => {
    if( window.location.host.indexOf( 'localhost' ) > -1 || window.location.host.indexOf( 'cockpit-staging.aciso-suite.com' ) > -1 || window.location.host.indexOf( 'adminportal.aciso-suite.com' ) > -1 ) {
      return `https://www.aciso.com/${ contentType }`
    } else if( window.location.host.indexOf( 'adminportal.tennis-suite.com' ) > -1 ) {
      return `https://www.tennis-people.com/${ contentType }`
    } else if( window.location.host.indexOf( 'adminportal.proof-point-suite.com' ) > -1 ) {
      return `https://www.proof-point.com/${ contentType }`
    }
  }

  return (
    <>
      {
        !_.isEmpty( props.data.platformConfigReducer.platformConfig ) 
        && _.find( props.data.platformConfigReducer.platformConfig, { key: 'PLATFORM_COLOR' } )
        && <ApplyBranding colors={{ primary: _.find( props.data.platformConfigReducer.platformConfig, { key: 'PLATFORM_COLOR' } ).value }} />
      }
      <TemplateContainerMain>
        <form style={{ height: "100vh" }} >
          <Row className="no-gutters" style={{ height: "100vh" }}>
            <Col lg="4" className="d-none d-lg-block">
              <div className="slider-light">
                {
                  window.location.host.indexOf( 'tennis' ) > -1 
                    ? (
                      <Slider { ...SliderSettings }>
                        <div >
                          <img 
                            src={ TennisBg } 
                            style={ SliderImageItemStyle } />
                        </div>
                      </Slider>
                    ) : (
                      <Slider { ...SliderSettings }>
                        <div
                          className="d-flex justify-content-start align-items-start bg-plum-plate">
                          <img 
                            src={ bg1 } 
                            style={ SliderImageItemStyle } />
                        </div>
                      </Slider>
                    )
                }
              </div>
            </Col>
            <Col 
              lg="8" 
              md="12" 
              style={{ height: "100vh" }}
              className="d-flex bg-white justify-content-center align-items-center" >
              <Col lg="9" md="10" sm="12" className="mx-auto app-login-box">
                <img 
                  src={
                    !_.isEmpty( props.data.platformConfigReducer.platformConfig ) 
                    && _.find( props.data.platformConfigReducer.platformConfig, { key: 'PLATFORM_ICON' } ) 
                      ? _.find( props.data.platformConfigReducer.platformConfig, { key: 'PLATFORM_ICON' } ).value
                      : ''
                  }
                  style={{ width: '150px', marginBottom: '0' }}/>
                <span style={{ fontSize: '20px', marginLeft: '15px' }}>Admin Portal</span>
                <Row className="divider"/>
                <AvForm>
                  <Row form>
                    {
                      (
                        ( props.ajaxReducer.ajaxErrorMessage !== '' && typeof props.ajaxReducer.ajaxErrorMessage !== 'object' ) ||
                        localStorage.getItem( 'IS_TOKEN_EXPIRED' )
                      ) && (
                        <Col md={ 12 }>
                          <Alert color="danger">
                            { 
                              ( localStorage.getItem( 'IS_TOKEN_EXPIRED' ) && 'Ihre Sitzung ist abgelaufen' ) || 
                              (
                                typeof props.ajaxReducer.ajaxErrorMessage === 'object' 
                                  ? JSON.stringify( props.ajaxReducer.ajaxErrorMessage ) 
                                  : props.ajaxReducer.ajaxErrorMessage 
                              )
                            }
                          </Alert>
                        </Col>
                      )
                    }
                    {
                      props.ajaxReducer.ajaxSuccessMessage && (
                        <Col md={ 12 }>
                          <Alert color="success">{ props.ajaxReducer.ajaxSuccessMessage }</Alert>
                        </Col>
                      )
                    }
                    <Col md={6}>
                      <AvGroup>
                        <Label for="exampleEmail">Email Adresse</Label>
                        <AvInput
                          onChange={ e => setState({ ...state, email: e.target.value })}
                          type="email"
                          name="email"
                          value={ state.email }
                          onKeyPress={ handleKeyPress }
                          required />
                      </AvGroup>
                    </Col>
                    <Col md={ 6 }>
                      <AvGroup>
                        <Label for="exampleEmail">Passwort</Label>
                        <AvInput
                          onChange={ e => setState({ ...state, password: e.target.value })}
                          type="password"
                          name="password"
                          value={ state.password }
                          onKeyPress={ handleKeyPress }
                          required />
                      </AvGroup>
                      <FormGroup style={{ textAlign: 'right' }}>
                        <Button color="link" onClick={() => props.history.push( '/forget-password' )}>PASSWORT VERGESSEN?</Button>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row className="divider" />
                  <div className="d-flex align-items-center mb-4">
                    <div className="ml-auto">
                      <Button
                        color="primary"
                        disabled={ buttonDisabled }
                        onClick={() => {
                          props.login({ 
                            email: state.email, 
                            password: state.password, 
                            accountLockIntervalId: state.accountLockIntervalId, 
                            onChangeAccountLockIntervalId: intervalId => setState({ ...state, accountLockIntervalId: intervalId }) 
                          })
                          window.localStorage.removeItem( 'IS_TOKEN_EXPIRED' )
                        }}>Login</Button>
                    </div>
                  </div>
                  <div 
                    style={{ flex: "1" }}
                    className='d-flex flex-row justify-content-end mb-2'>
                    <Captcha
                      lang='de'
                      onHandleDone={ () => setButtonDisabled( false ) }
                      onHandleError={ () => {} }
                    />
                  </div>
                </AvForm>
              </Col>
              <div style={{ position: 'fixed', bottom: '30px', fontSize: '17px' }}>
                <a href={ handleRedirectLink( 'impressum' ) } target="_blank" className='mr-3'>Impressum</a>
                <a href={ handleRedirectLink( 'datenschutz' ) } target="_blank">Datenschutz</a>
              </div>
            </Col>
          </Row>
        </form>
        { props.ajaxReducer.ajaxCallProgress > 0 && <LoadingOverlay /> }
      </TemplateContainerMain>
    </>
  )
}

const mapStateToProps = state => ({
  data: state,
  ajaxReducer: state.ajaxReducer
})

export default connect( mapStateToProps, {
  login,
  unlockAccount,
  getPlatformConfig,
  clearProfile,
  clearSelectedRole,
  setSelectCenter
})( 
  props => (
    <CaptchaContextProvider>
      <Login {...props} />
    </CaptchaContextProvider> 
  )
);
